import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgViewCrosstab = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.284 12.31H5.625V5.63h6.66zm0 30.06H5.625V15.65h6.66zm30.091-30.06h-26.72V5.63h26.72zm-20.06 10.02h-6.66v-6.68h6.66zm0 10.02h-6.66v-6.68h6.66zm3.37-16.7h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zm10.031-10.02h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zm-13.401 16.7h-6.66v-6.68h6.66zm10.03 0h-6.659v-6.68h6.66zm3.371-6.68h6.659v6.68h-6.659z" })
});
export default SvgViewCrosstab;
